const GUIDE_INCENTIVES = ['stress', 'save'] as const;
export type GuideIncentive = (typeof GUIDE_INCENTIVES)[number];

export const isGuideIncentive = (
  value: string | undefined,
): value is GuideIncentive =>
  GUIDE_INCENTIVES.includes(value as GuideIncentive);
